<template>
  <modal id="editPtMapping"
         :show="showModal"
         modal-classes="modal-dialog-centered modal-lg"
         showClose
         @close="close"
  >
    <template slot="header">
      <h4 class="modal-title">
        {{ $t('ptMappings.edit.titleText') }}
      </h4>
    </template>
    <template>
      <div class="text-center text-muted mb-2">
        <small>{{ $t('ptMappings.edit.helpText') }}</small>
      </div>

      <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
        <!-- TODO: add error translation -->
        {{ getActionErrorDetails }}
      </base-alert>

      <form role="form" @submit.prevent="validate()">
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptMappings.details.operator_id') }}</label>
          <div class="col-sm-9">
            <base-input
              :error="getError('operator_id')">
              <el-select
                name="operator_id"
                data-vv-as="'operator_id'"
                class="select-primary"
                v-validate="modelValidations.required"
                v-model="formDetails.operator_id">
                <el-option
                  v-for="option in operators"
                  class="select-primary"
                  :value="option.id"
                  :label="option.id"
                  :key="option.id">
                </el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptMappings.form.garage_number') }}</label>
          <div class="col-md-9">
            <base-input
              data-vv-as="'garage_number'"
              name="garage_number"
              v-validate="modelValidations.required"
              :error="getError('garage_number')"
              v-model="formDetails.garage_number"
              step="0.01"/>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptMappings.form.mapping_id') }}</label>
          <div class="col-md-9">
            <base-input
              data-vv-as="'mapping_id'"
              name="mapping_id"
              v-validate="modelValidations.mappingLength"
              :error="getError('mapping_id')"
              v-model="formDetails.mapping_id"
              step="0.01"/>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptMappings.details.vehicle_type') }}</label>
          <div class="col-sm-9">
            <base-input
              :error="getError('vehicle_type')">
              <el-select
                name="vehicle_type"
                data-vv-as="'vehicle_type'"
                class="select-primary"
                v-validate="modelValidations.required"
                v-model="formDetails.vehicle_type">
                <el-option
                  v-for="option in vehicleTypes"
                  class="select-primary"
                  :value="option"
                  :label="option"
                  :key="option">
                </el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="text-center">
          <base-button
            type="info"
            :loading="updating"
            class="my-4"
            native-type="submit"
          >{{ $t('ptMappings.edit.actionBtnLabel') }}
          </base-button>
        </div>
      </form>
    </template>
  </modal>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'edit-fare-group',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  props: {
    formDetails: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
    operators: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      alert: false,
      modelValidations: {
        mappingLength: {
          required: true,
          min: 3
        }
      }
    }
  },
  computed: {
    ...mapState({
      updating: state => state.pt_mapping.updating,
      error: state => state.pt_mapping.error,
      vehicleTypes: state => state.pt_mapping.vehicleTypes,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
    showModal() {
      return this.show == true
    }
  },
  methods: {
    ...mapActions(['UpdatePTMapping']),
    close: function () {
      this.$emit('close');
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.update()
        }
      });
    },
    update: function () {
      this.UpdatePTMapping(this.formDetails).then(() => {
        if (this.error != null) {
          this.alert = true
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('ptMappings.edit.updatedNotification', this.formDetails),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.close()
        }
      });
    }
  }
}
</script>
